import 'jquery-validation'; //npm
require('./core/formbuilder/form');

